const en = {

    '登录': 'login',
    '帐号或密码错误': 'Wrong account or password',
    '中文': 'zh',
    '英文': 'en',
    '白天主题': 'day',
    '夜晚主题': 'night',
    '进出口': 'Import & Export',
    '查询': 'Search',
    '内容': 'content',
    '添加': 'Add',
    '操作': 'Operation',
    '查看': 'Check',
    '删除': 'Delete',
    '修改': 'Revise',
    '编辑': 'Revise',
    '保存': 'Save',
    '取消': 'Cancel',
    '确认': 'OK',
    '基础': 'basic',
    '权限': 'prom',
    '请选择': 'select',
    '日期以前': 'Date Before',
    '日期以后': 'Date After',
    '日期区间': 'Date Range',
    '批量删除': 'Batch Deletion',
    '是否确认批量删除？': 'Confirm batch deletion？',
    '是否确认删除？': 'sure to delete？',
    '嘉兴高瓴信息科技有限公司': 'JiaXingGaoLing Ltd.',
    '导出': 'export',
    //质检通用
    '采购单编号': 'Purchase Number',

    '生产工厂': 'Factory',
    '产品名称': 'Product Name',
    '订单数量': 'Order Quantity',
    '状态': 'Status',
    '检验人员': 'Inspectors',
    '检验时间': 'Test Time',
    '质检状态': 'Inspection Status',
    '检验结果': 'Test Result',
    '质检日期': 'Inspection date',
    '检验日期': 'Inspection date',

    //一级菜单栏
    '系统管理': 'System Management',
    '基础设置': 'Basic Settings',
    '数据报表': 'Data Report',
    '检验流程': 'Inspection Process',
    '订单资料': 'Order Information',

    //二级菜单栏
    '首页': 'Home',
    '我的审批': 'My Approval',
    '货号管理': 'Sku Management',
    '订单管理': 'Order Management',
    '文件管理': 'File Management',
    '待纠正问题': 'Pengding Action',
    '新样品检验': 'First Sample Inspection',
    '原材料检验': 'Raw Material Inspection',
    '产前样检验': 'PP Sample Inspection',
    '中期检验': 'Mid-Term Inspection',
    '尾期检验': 'Final Inspection',
    '复检': 'Reinspection',
    '大货样检验': 'Production Sample Inspection',
    '质量纠正8D报告': 'Quality Corrective Actions Report 8D',
    '数据源配置': 'Data Source Configuration',
    '供应商报告--月报': 'Supplier Report-Monthly Report',
    '企业管理': 'Business Management',
    '校验标准管理': 'Inspection Standards',
    '验收问题类别管理': 'Category Of Acceptance Issues',
    '测试项目配置': 'Test Project Configuration',
    '配件信息管理': 'Sparepart Info.',
    '进出口公司管理': 'Import&Export Company Management',
    '权限管理': 'Authorization Management',
    '人员管理': 'User Management',
    '部门管理': 'Department Management',

    '栏目管理': 'Columns',
    '用户管理': 'Users',
    '供应商管理': 'Suppliers',
    '工厂管理': 'Factory',
    '联系人管理': 'Contacts',

    //首页表头
    '待审批列表': 'Pending',
    '通知公告': 'Announcement',
    '消息列表': 'Message Lists',

    //我的审批表头
    '审批状态': 'Approval Status',
    '申请人': 'Proposer',
    '货号/编号/名称': 'Sku/Sample Number/Name',
    '申请日期': 'Application date',
    '审批结果': 'Audit Result',
    '审批时间': 'Audit Time',
    //货号表头
    '货号': 'Sku',
    '工厂': 'Factory',
    '供应商': 'Supplier',
    '签封样': 'Seal Sample',
    '组装图': 'Assembly Drawing',
    '工艺单': 'Single Process',
    '以往报告': 'Previous Reports',
    '质量整改': 'Quality Rectification',
    '关键字': 'Keywords',
    '添加组装图': 'Add Assembly Drawing',
    '添加签封样': 'Add Seal Sample',
    '添加工艺单': 'Add Process Sheet',

    //订单管理表头
    '采购单号': 'Purchase Number',
    '备注': 'Remarks',
    '预计发货日': 'Etd',
    '计划数量': 'Planned Quantity',
    '已验数量': 'Inspected Quantity',

    //文件管理表头
    '文件夹': 'Folder',
    '创建时间': 'Creation Time',
    '创建人': 'Founder',
    '文件夹名': 'Folder Name',
    '接收方': 'Receiver',
    '修改人': 'Modifier',
    '新建文件夹': 'New Folder',
    '文件上传': 'File Upload',
    '文件': 'File',
    '文件描述': 'File Description',
    '请选择文件夹': 'please select rule',

    //待纠正问题表头
    '问题描述': 'Problem Description',
    '忽略原因': 'Ignore Reason',

    //新样品检验表头
    '样品编号': 'Sample Number',
    '样品名称': 'Sample Name',
    '样品来源': 'Sample Source',
    '到样时间': 'Sample Time',
    '打样工厂': 'Factory',

    //原材料检验表头
    '原材料名称': 'Raw Material Name',
    '客户': 'Client',
    '原材料品牌': 'Raw Material Brand',
    '来料数量': 'Incoming Quantity',
    '验收工厂': 'Factory',

    //产前样检验表头

    //尾期检验表头
    '抽检标准': 'Random Inspection Standard',
    '品质标准': 'Quality Standard',

    //复检表头
    '五位码': 'Product Code',
    'EAN码': 'Bar Code',

    //大货样表头
    '条形码': 'Bar code',
    '包装尺寸': 'Package Dimensions',
    '中文品名': 'Chinese Name',
    '组装日期': 'Assembly Date',

    //质量纠正8D报告表头
    '操作人': 'Operator',
    '录入日期': 'Entry Date',
    '完成数': 'Completed',
    '已纠正数': 'Processed',
    '正在处理数': 'Processing',
    '待纠正数': 'Pengding',

    //数据源配置表头
    '导入': 'Import',
    '序号': 'Serial Number',
    '类型': 'Type',
    '日期': 'Date',
    '月份': 'Mouth',
    '产品等级': 'Product Classification',
    '品管负责人': 'Qc',
    '出库量': 'Outbound Quantity',
    '投诉量': 'Complaints',
    '投诉损失额': 'Complaint Loss',
    '投诉原因': 'Complaint Reason',
    '投诉分类': 'Complaint Category',
    '亚马逊评分': 'Amazon Rating',

    //供应商报告表头
    '模板名称': 'Template Name',
    '评分数据来源': 'Rating Data Source',
    '评分数据说明': 'Rating Data Description',
    '投诉数据来源': 'Complaint Data Source',
    '投诉率目标': 'Complaint Rate Target',
    '整体评价一': 'Appraisal(1)',
    '整体评价二': 'Appraisal(2)',
    '整体评价三': 'Appraisal(3)',
    '落款': 'Sign',
    '年报': 'Annual Report',
    '月报': 'Monthly Report',
    '季报': 'Quarterly Report',

    //企业管理表头
    '企业简称': 'Company',
    '企业全称': 'Company Name',
    '企业编号': 'Company Id',
    '企业类型': 'Company Type',
    '省份': 'Province',
    '城市': 'City',
    '地址': 'Address',

    //检验标准管理表头
    '检验标准名称': 'Inspection Standard Name',
    '标准起始值': 'Standard Start Value',
    '标准结束值': 'Standard End Value',

    //验收问题类别表头
    '验收问题类别名称': 'Acceptance Issues Category Name',

    //测试项目配置表头
    '测试项目': 'Test Items',
    '结果判定': 'Result',
    '测试方法': 'Test Method',

    //配件信息管理表头
    '配件编号': 'Sparepart Number',
    '大类': 'Category-Ⅰ',
    '小类': 'Category-Ⅱ',
    '配件名称': 'Sparepart Name',
    '尺寸': 'Size',
    '颜色': 'Color',
    '材质': 'Material',
    '表面处理': 'Surface Treatment',
    '适用货号': 'Item Number',

    //进出口公司管理表头
    '公司名称': 'Company Name',
    '负责人': 'Person In Charge',
    '手机号码': 'Phone Number',
    '邮箱': 'E-Mail',
    '微信': 'Wechat',
    '职务': 'Position',

    //权限管理
    '角色': 'Role',
    '描述': 'Description',

    //人员管理表头
    '公司': 'Company',
    '部门': 'Department',
    '账号': 'Account',
    '用户名': 'User Name',
    '联系方式': 'Contact Information',

    //部门管理表头
    '上级部门': 'Superior Department',
    '部门名称': 'Department Name',

    '索贝QC检验系统后台': 'Sobuy QC',


    el: {
        colorpicker: {
            confirm: 'OK',
            clear: 'Clear'
        },
        datepicker: {
            now: 'Now',
            today: 'Today',
            cancel: 'Cancel',
            clear: 'Clear',
            confirm: 'OK',
            selectDate: 'Select date',
            selectTime: 'Select time',
            startDate: 'Start Date',
            startTime: 'Start Time',
            endDate: 'End Date',
            endTime: 'End Time',
            prevYear: 'Previous Year',
            nextYear: 'Next Year',
            prevMonth: 'Previous Month',
            nextMonth: 'Next Month',
            year: '',
            month1: 'January',
            month2: 'February',
            month3: 'March',
            month4: 'April',
            month5: 'May',
            month6: 'June',
            month7: 'July',
            month8: 'August',
            month9: 'September',
            month10: 'October',
            month11: 'November',
            month12: 'December',
            week: 'week',
            weeks: {
                sun: 'Sun',
                mon: 'Mon',
                tue: 'Tue',
                wed: 'Wed',
                thu: 'Thu',
                fri: 'Fri',
                sat: 'Sat'
            },
            months: {
                jan: 'Jan',
                feb: 'Feb',
                mar: 'Mar',
                apr: 'Apr',
                may: 'May',
                jun: 'Jun',
                jul: 'Jul',
                aug: 'Aug',
                sep: 'Sep',
                oct: 'Oct',
                nov: 'Nov',
                dec: 'Dec'
            }
        },
        select: {
            loading: 'Loading',
            noMatch: 'No matching data',
            noData: 'No data',
            placeholder: 'Select'
        },
        cascader: {
            noMatch: 'No matching data',
            loading: 'Loading',
            placeholder: 'Select',
            noData: 'No data'
        },
        pagination: {
            goto: 'Go to',
            pagesize: '/page',
            total: 'Total {total}',
            pageClassifier: ''
        },
        messagebox: {
            title: 'Message',
            confirm: 'OK',
            cancel: 'Cancel',
            error: 'Illegal input'
        },
        upload: {
            deleteTip: 'press delete to remove',
            delete: 'Delete',
            preview: 'Preview',
            continue: 'Continue'
        },
        table: {
            emptyText: 'No Data',
            confirmFilter: 'Confirm',
            resetFilter: 'Reset',
            clearFilter: 'All',
            sumText: 'Sum'
        },
        tree: {
            emptyText: 'No Data'
        },
        transfer: {
            noMatch: 'No matching data',
            noData: 'No data',
            titles: ['List 1', 'List 2'], // to be translated
            filterPlaceholder: 'Enter keyword', // to be translated
            noCheckedFormat: '{total} items', // to be translated
            hasCheckedFormat: '{checked}/{total} checked' // to be translated
        },
        image: {
            error: 'FAILED'
        },
        pageHeader: {
            title: 'Back' // to be translated
        },
        popconfirm: {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }
    },
}
export default en
